<div class="max-w-full mx-auto p-2">
  <!-- Solo mostrar este botón si el usuario es un Administrador -->
  <button *ngIf="userRole === 'ROLE_ADMIN'"
    class="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 mb-7 rounded"
    (click)="openProviderFormModal()">Agregar Proveedor
  </button>

  <div *ngIf="displayedProviders.length > 0" class="mt-8">
    <h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">LISTADO DE PROVEEDORES</h2>
    <div class="overflow-x-auto shadow-2xl rounded-lg rounded-b-none">
      <table class="w-full leading-normal">
        <thead class="bg-orange-500 text-white">
          <tr>
            <th class="px-2 py-2 border-b-2 border-orange-600">ID</th>
            <th class="px-2 py-2 border-b-2 border-orange-600">Nombre</th>
            <th class="px-2 py-2 border-b-2 border-orange-600">Tipo</th>
            <th class="px-2 py-2 border-b-2 border-orange-600">Estado</th>
            <th class="px-2 py-2 border-b-2 border-orange-600">Complejidad</th>
            <th class="px-2 py-2 border-b-2 border-orange-600">Acciones</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr *ngFor="let provider of displayedProviders" class="hover:bg-gray-200 transition duration-150 ease-in-out">
            <td class="px-2 py-3 border-b border-gray-200 text-center align-middle">{{ provider.id }}</td>
            <td class="px-2 py-3 border-b border-gray-200 text-center align-middle">{{ provider.name }}</td>
            <td class="px-2 py-3 border-b border-gray-200 text-center align-middle">{{ provider.type }}</td>
            <td class="px-2 py-3 border-b border-gray-200 text-center align-middle">{{ provider.status }}</td>
            <td class="px-2 py-3 border-b border-gray-200 text-center align-middle">{{ provider.complexity }}</td>
            <td class="px-2 py-3 border-b border-gray-200 text-center align-middle">
              <button (click)="openUpdateModal(provider)" matTooltip="Editar" matTooltipShowDelay="300"
                class="bg-orange-500 hover:bg-orange-700 text-white font-light mx-2 py-2 px-2 rounded">
                <mat-icon>create</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="displayedProviders.length === 0 && !isLoading" class="bg-white shadow-md rounded-lg mt-5 p-5">
    <h1 class="text-2xl font-bold text-center text-gray-600">
      No se encontraron proveedores.
    </h1>
  </div>

  <ng-container *ngIf="providers.length > 0">
    <div class="relative mb-5">
      <mat-paginator [length]="totalProviders" hidePageSize="true" [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize" [pageIndex]="pageIndex" (page)="handlePageEvent($event)">
      </mat-paginator>
    </div>
  </ng-container>

  <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
    <svg class="animate-spin h-5 w-5 text-orange-500 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none"
      viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
      </path>
    </svg>
  </div>
</div>